import { Anchor } from "client/Components";
import { ReactElement } from "react";
import { TermsArticle } from "./termsArticles";
import styles from "./TermsArticleLinkList.module.less";

export type TermsArticleLinkListProps = {
	articles: readonly TermsArticle[];
};

export const TermsArticleLinkList = (props: TermsArticleLinkListProps): ReactElement => {
	const { articles } = props;

	return (
		<ul className={styles.root}>
			{articles.map(x => (
				<li key={x.trackingId}>
					<Anchor
						href={x.url}
						target="_blank"
						trackingId={x.trackingId}
					>
						{x.name}
					</Anchor>
				</li>
			))}
		</ul>
	);
};
TermsArticleLinkList.displayName = "TermsArticleLinkList";
